import React from "react";
import GaugeComponent from "react-gauge-component";
import "./Guage.css";

interface GuageProps {
  value: number; // 0 to 100
  label?: string;
}

const GuageChart: React.FC<GuageProps> = ({ value, label = "Claim Rate" }) => {
  return (
    <div className="guageContainer main">
      <h3 className="guageTitle">Total Claim Rate</h3>
      <div className="guageContainer">
        <GaugeComponent
          value={value}
          minValue={0}
          maxValue={100}
          type="semicircle"
          arc={{
            colorArray: ["#4caf50", "#ffeb3b", "#f44336"],
            subArcs: [
              { limit: 10, color: "#4caf50" }, // Green: 0-10
              { limit: 30, color: "#ffeb3b" }, // Yellow: 11-30
              { limit: 100, color: "#f44336" }, // Red: 31-100
            ],
            padding: 0.01,
            width: 0.2,
          }}
          pointer={{
            color: "#222",
            length: 0.8,
            width: 8,
          }}
          labels={{
            valueLabel: {
              formatTextValue: (v: number) => `${v}%`,
              style: { fontSize: "2rem", fontWeight: "bold" },
            },
            nameLabel: {
              text: label,
              style: { fontSize: "1rem" },
            },
          }}
        />
        <div className="legend">
          <div className="legendItem">
            <span className="greenBox"></span> (0-10%)
          </div>
          <div className="legendItem">
            <span className="yellowBox"></span> (11-30%)
          </div>
          <div className="legendItem">
            <span className="redBox"></span> (31-100%)
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuageChart;
